<template>
    <section
        class="page-width p-relative"
        @mouseleave="mouseLeave"
        v-show="show"
        @mouseenter="mouseEnter"
    >
        <div class="course-top-classify">
            <ul>
                <li v-show="showUp" @click="up">
                    <p class="arrow up">〉</p>
                </li>
                <li
                    v-for="(c, index) in thisCategory"
                    :class="{active: currentCategory == c}"
                    v-show="showIndex(index)"
                    @mouseenter="enterClassify(c)"
                    @click="toCategoryList(c)"
                    :key="index"
                >{{ c.name }}</li>
                <li v-show="showDown" @click="down">
                    <p class="arrow down">〉</p>
                </li>
            </ul>
        </div>
        <div class="course-top-classbox" v-if="currentCategory">
            <!--开始分类-->
            <div class="inner">
                <div class="inner-class">
                    <div class="inner-title" data-url="/vod/e0GZ">{{ currentCategory.name }}</div>
                    <template v-for="(s, index) in thisSubCategory[currentCategory.id]">
                        <a @click="toCategoryList(currentCategory, s)" :key="index">{{ s.name }}</a>
                        <em
                            v-if="index + 1 < thisSubCategory[currentCategory.id].length"
                            :key="index"
                        >|</em>
                    </template>
                </div>
                <div class="inner-course" v-if="recommend.length">
                    <div class="inner-title">
                        <span>
                            <a href="#">更多&gt;&gt;</a>
                        </span>推荐课程
                    </div>
                    <ul>
                        <li v-for="r in recommend" :key="r.id">
                            <div class="img">
                                <a href="#" target="_blank">
                                    <pic :src="r.img" class="m-img" />
                                </a>
                            </div>
                            <div class="name">
                                <a href="#" target="_blank">{{ r.name }}</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!--结束分类-->
        </div>
    </section>
</template>
<script>
export default {
    name: 'category',
    props: ['category', 'subCategory', 'showCategory'],
    data() {
        return {
            currentCategory: null,
            recommend: [],
            showCount: 0,
            thisCategory: this.category || [],
            thisSubCategory: this.subCategory,
            start: 0
        }
    },
    computed: {
        show() {
            return this.showCategory + this.showCount
        },
        showUp() {
            return this.start > 0
        },
        showDown() {
            return this.thisCategory.length - this.start > 9
        }
    },
    methods: {
        toCategoryList(category, subCategory) {
            let params = {
                id: category.id,
                category: category,
                children: this.thisSubCategory[category.id]
            }
            if (subCategory) {
                params.subId = subCategory.id
                this.$router.push({ name: 'subCourseList', params: params })
            } else {
                this.$router.push({ name: 'courseList', params: params })
            }
        },
        enterClassify(c) {
            this.currentCategory = c
        },
        mouseEnter() {
            this.showCount += 1
        },
        mouseLeave() {
            this.currentCategory = null
            var _this = this
            setTimeout(function() {
                _this.showCount -= 1
            }, 20)
            this.$emit('mouseLeave')
        },
        showIndex(index) {
            let max = 9
            if (this.showUp) {
                max -= 1
            }
            if (this.showDown) {
                max -= 1
            }
            return index >= this.start && index - this.start < max
        },
        up() {
            if (this.start === 2) {
                this.start -= 1
            }
            this.start -= 1
        },
        down() {
            if (this.start === 0) {
                this.start += 1
            }
            this.start += 1
        }
    },
    created() {
        if (!this.thisCategory || !this.thisCategory.length) {
            var _this = this
            this.$http
                .get(this.$coursePath + '/index/training/categories')
                .then(function(result) {
                    if (result.data.code == 0) {
                        let data = result.data.data
                        _this.thisCategory = data.root
                        _this.thisSubCategory = data.data
                    } else {
                        alert(result.data.message)
                    }
                })
        }
    }
}
</script>
<style scoped>
@import '../assets/css/common.css';
@import '../assets/css/index.css';
li p.arrow {
    width: 35px;
    height: 35px;
    line-height: 35px;
    left: 50%;
    top: 50%;
    position: absolute;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

li .up {
    transform: translate(-50%, -50%) rotate(-90deg);
    -ms-transform: translate(-50%, -50%) rotate(-90deg);
    -webkit-transform: translate(-50%, -50%) rotate(-90deg);
    -o-transform: translate(-50%, -50%) rotate(-90deg);
    -moz-transform: translate(-50%, -50%) rotate(-90deg);
}

li .down {
    transform: translate(-50%, -50%) rotate(90deg);
    -ms-transform: translate(-50%, -50%) rotate(90deg);
    -webkit-transform: translate(-50%, -50%) rotate(90deg);
    -o-transform: translate(-50%, -50%) rotate(90deg);
    -moz-transform: translate(-50%, -50%) rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/views/categoryView.vue